import _http from './statis_http';
import { getSignStatis, getUrlParams } from '@/utils';
import store from '@/store';

// 新统计sdk
const host = window.location.host;
let baseURL = `https://api-sdk-statis.lnqwe.com`;
if (host.indexOf('apisdk.lnqwe') > -1) {
  baseURL = `https://api-sdk-statis.lnqwe.com`
} else {
  baseURL = `https://api-sdk-statis.lnqwe.com`
}
let randDate = String(new Date().valueOf()) + 'RD' + Math.floor((Math.random()*10000000)+1);
const http = _http.create({
  baseURL
});
// 激活
export const appActive = (params) => {
    return http( {
      url: '/api/v1/activation/activate',
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        'LN-Request-ID': randDate,
        'Api-Sign-Type': 'MD5',
        'Api-Sign': get_api_sign(params, randDate)
      },
    } )
  }
  // 事件上报
  export const appEventReport = (params) => {
    console.log(params, 666666)
    return http( {
      url: '/api/v1/event_log/report',
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        'LN-Request-ID': randDate,
        'Api-Sign-Type': 'MD5',
        'Api-Sign': get_api_sign(params, randDate)
      },
    } )
  }

  function get_api_sign(data, randDate) {
    const sign_params = {
     series_id: store.state.series_id,
     package_version: parseInt(getUrlParams('ver') || 0),
     campaign: getUrlParams('campaign_id') || '',
     event: data.event,
     game_id: parseInt(getUrlParams('game_id') || 0),
     fu_appid: parseInt(getUrlParams('appid') || 0),
     package_name: getUrlParams('package_name') || 'h5',
     sdk_channel: getUrlParams('sdk_channel') || 'leniu',
     game_zone_id: store.state.zoneId || '',
     is_charge: getUrlParams('is_charge') || 0,
     network: getUrlParams('network') || 0,
     time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
     request_id: randDate,
    }
    return getSignStatis('4slqksr2ca94h6etps517g768815rydr', data, randDate)
   }
